module.exports = __webpack_public_path__ + "img/7.b7aab97d.png";